/**
 * @deprecated See DeliveryStore's actions at src/delivery/store/actions.js
 */

import api from '@/store/api'
import PATHS from '@/router/paths'
import transform from '@/utils/transform'

const actions = {
  async getData({ dispatch }, reportKey) {
    return dispatch('setView', reportKey)
  },
  /*
   * Fetches request from the API, passing the parameters along.
   * @param {Object} context
   * @param {Object} data
   * @param {function} data.catcher Function passed to Promise's catch in case of error
   * @param {Object} data.params { dateRange, reportId, subId }
   */
  fetch(context, { catcher, params, reportKey }) {
    const fetchMap = {
      [PATHS.REPORTS.ADX_HEALTH]: () => api.getHealthAdx(params).catch(catcher),
      [PATHS.REPORTS.NETWORK_HEALTH]: () => api.getHealthNetwork(params).catch(catcher),
      [PATHS.REPORTS.YIELD_PARTNER]: () => api.getYieldPartner(params).catch(catcher),
    }
    return fetchMap[reportKey]()
  },
  async transform({ dispatch }, data) {
    const { columnsByKey, params } = data
    const { networkCode } = params

    const transformer = transform.freezeAll.bind(transform, networkCode, columnsByKey)

    return dispatch('tools/transformData', { data, transformer }, { root: true })
  },
  async request({ dispatch }, { moduleName = 'programmatic', params, reportKey }) {
    const root = { root: true }
    const endpointName = reportKey
    const applyFilters = moduleName === reportKey
    const requestReport = { applyFilters, endpointName, moduleName, reportKey }

    const handler = await dispatch('tools/requestHandler', requestReport, root)
    const { catcher } = handler
    const response = await dispatch('fetch', { catcher, params, reportKey })

    return { ...requestReport, handler, response }
  },
  summaries({ dispatch, rootState }, itemsReport) {
    const { summaries } = rootState.tools
    const isAlert = false

    itemsReport.isAlert = itemsReport.isAlert || isAlert
    itemsReport.summaries = summaries

    dispatch('tools/summaries', itemsReport, { root: true })
  },
  async render({ dispatch }, data) {
    // @param {Object} data { columnsByKey, handler, params, reportKey, requestReport, response }
    const results = await dispatch('transform', data)

    data.items = results.items

    dispatch('summaries', data).catch((error) => {
      const logger = console
      logger.warn('SUMMARIES', error)
    })

    dispatch('messages/hideLoadingMessage', { reportKey: data.reportKey, text: 'Rendering ...' }, { root: true })

    return results
  },
  /**
   * Get data with additional progress updates for the view.
   * @param {Object} context
   * @param {string} reportKey
   */
  async setView({ dispatch, rootGetters, rootState }, reportKey) {
    const root = { root: true }
    const moduleName = reportKey
    const columnsByKey = rootGetters['tools/columnsByKey']
    const params = rootState.tools.currentReportParams

    dispatch('messages/showLoadingMessage', { reportKey, text: 'Requesting data...' }, root)

    const requestReport = await dispatch('request', { moduleName, params, reportKey })

    dispatch('messages/showLoadingMessage', { reportKey, text: 'Transforming...' }, root)

    return dispatch('render', { ...requestReport, columnsByKey, params, reportKey })
  },
  openAdServerLink(context, item) {
    const target = '_blank'

    window.open(item.adServerLink, target)
  },
}

export default actions
